export default __webpack_public_path__ + "static/favicon-0b2f4940edbac4dfc0c4784e481ebec6.ico";